// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"b6f20a99adbd038892e1","678":"c898ba525d8519c4461e","731":"3638a44a07caa8e40a51","843":"cff4afe7cadcd319a1bf","883":"0474631a40f6678a915f"}[chunkId] + ".js";
};